import { useEffect, useState } from 'react';

const useResize = () => {
  const [data, setData] = useState({
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  });

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const resizeListener = () => {
      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(() => {
        setData((prev) => ({
          ...prev,
          windowWidth: window.innerWidth,
          windowHeight: window.innerHeight,
        }));
      }, 50);
    };

    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, [data]);

  return data;
};

export default useResize;
